import { Injectable } from '@angular/core';
import { PlatformDetect } from '@libs/platform/platform-detect';
@Injectable({
  providedIn: 'root'
})
export class JSBridgeService {
    public _bridge: any;

    constructor(
        private platform: PlatformDetect
    ) { }

    public async initJsBridge(): Promise<void> {
        if (!this._bridge && this.platform.isApp()) { 
            this._bridge = await this.getDisneyJSBridge();
            console.log('init _bridge...', this._bridge);
        }
    }

    private async getDisneyJSBridge(): Promise<any> {
        let count = 0;
        return new Promise((resolve) => {
            let DisneyJSBridge = (window as any)['DisneyJSBridge'];
            let timer: any = null;
            if (!DisneyJSBridge) {
                timer = setInterval(() => {
                    DisneyJSBridge = (window as any)['DisneyJSBridge'];
                    count += 1;
                    if (DisneyJSBridge || count >= 10) {
                        clearInterval(timer);
                        resolve(DisneyJSBridge);
                    }
                }, 50);
            } else {
                clearInterval(timer);
                resolve(DisneyJSBridge);
            }
        });
    }

    async callJSBridge(method: string, params: any = {}, cb?: any): Promise<any>{
        console.log(`callBridge start ${method}:`, params);
        if (this._bridge) {
            return this.triggerBridge(method, params, cb);
        } else {
            this._bridge = await this.getDisneyJSBridge();
            if (this._bridge) {
                return this.triggerBridge(method, params, cb);
            }
        }
    }

    private async triggerBridge(method: string, params: any = {}, cb?: any) {
        return new Promise((resolve, reject) => {
            try {
                this._bridge.call(method, params, cb? cb: async (resp: any) => {
                    resolve(resp);
                    console.log(`callBridge end ${method}:`, resp);
                });
            } catch (err) {
                console.log(`callJSBridge ${method} error:`, err);
            }
        });
    }

    //route for trgart link
    public async routeWithURL(path: string): Promise<any> {
        if (this._bridge) {
            return new Promise(() => {
                try {
                    this._bridge.call('routeWithURL', { url: path});
                } catch (error) {
                    console.log('routeWithURL error:', error)
                }
            })
        } else { 
            console.log('no DisneyJSBridge...');
        }
    }

}
